'use client';

import { Button } from '@/components/ui/button';
import type { ImportKind } from '@borradh-workspace/api-client/types';
import { UploadIcon } from 'lucide-react';
import { useState } from 'react';
import { useAppImporter } from '../api';
import { ImportDataDialog } from './import-data-dialog';

interface ImportDataButtonProps {
  /** The page's own kind, preselected when the file is ambiguous. */
  kind?: ImportKind;
  className?: string;
}

/** The one "Import" button: same look and behaviour on every page. */
export function ImportDataButton({ kind, className }: ImportDataButtonProps) {
  const [open, setOpen] = useState(false);
  const importer = useAppImporter();
  return (
    <>
      <Button
        className={className}
        onClick={() => setOpen(true)}
        size="sm"
        type="button"
        variant="outline"
      >
        <UploadIcon className="size-4" />
        Import
      </Button>
      {open && (
        <ImportDataDialog
          importer={importer}
          kind={kind}
          onOpenChange={setOpen}
          open
        />
      )}
    </>
  );
}
